import { Navigate, useLocation } from "react-router-dom"

import { solarSummaryPath } from "./solar-summary-steps"

/**
 * To the Summary, keeping the query string and hash, with where the link
 * pointed as `returnTo` so Confirm & open lands there.
 */
export const SolarSummaryRedirect = ({
  proposalId,
}: {
  proposalId: string
}): JSX.Element => {
  const { hash, pathname, search } = useLocation()
  return (
    <Navigate
      to={`${solarSummaryPath(proposalId)}${search}${hash}`}
      state={{ returnTo: `${pathname}${search}${hash}` }}
      replace
    />
  )
}
